import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Title, Fieldset } from "rbx";
import { useMutation } from "react-apollo";
import {
  UPDATE_PRODUCT_MUTATION,
  DELETE_PRODUCT_MUTATION
} from "../../graphql/Products/Products.graphql";
import { ourToast as toast } from "../../utils";
import { useSystemCodes } from "../../utils/hooks";
import Loading from "../Loading";
import ProductForm from "./ProductForm";
import { EditFormButtonGroup } from "../inputs";

const DEFAULT_STATE = {
  ProductCode: "",
  Description: "",
  ProductGroupRecIdRef: "",
  ProductCatgRecIdRef: "",
  UOMRecIdRef: "",
  HazmatCode: "",
  Active: true,
  Mandatory: false,
  Price: 0,
  Percentage: "",
  Note: "",
  CalcTypeRecIdRef: "",
  RevGLRecIdRef: "",
  ListOrder: ""
};

const EditProductForm = ({ onComplete, product }) => {
  const [inputs, setInputs] = useState(product);
  const [codes, setCodes] = useState(null);
  const { data: systemCodes } = useSystemCodes({
    Category_in: ["General Ledger", "Product"],
    CodeName_in: ["AcctType", "ProductCatg"]
  });

  useEffect(() => {
    if (!codes && Array.isArray(systemCodes)) {
      setCodes({
        revenue: systemCodes.find(
          c => c.CodeName === "AcctType" && c.CodeId === "R"
        ),
        fee: systemCodes.find(
          c => c.CodeName === "ProductCatg" && c.CodeId === "FEE"
        ),
        sale: systemCodes.find(
          c => c.CodeName === "ProductCatg" && c.CodeId === "SALE"
        )
      });
    }
  }, [codes, systemCodes]);

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [e.target.name]: value });
  };
  const [updateProduct, { loading }] = useMutation(UPDATE_PRODUCT_MUTATION, {
    refetchQueries: ["ALL_PRODUCTS_QUERY"]
  });
  const handleSave = async e => {
    e.preventDefault();
    if (
      parseInt(inputs.ProductCatgRecIdRef) === codes.sale.RecId &&
      !parseInt(inputs.ProductGroupRecIdRef)
    ) {
      toast.error("Product Group is required");
    } else {
      const obj = Object.keys(DEFAULT_STATE).reduce(
        (acc, curr) =>
          inputs[curr] !== null ? { ...acc, [curr]: inputs[curr] } : acc,
        {}
      );
      try {
        await updateProduct({
          variables: {
            data: {
              ...obj,
              ListOrder: inputs.ListOrder
                ? parseInt(inputs.ListOrder, 10)
                : null,
              ProductGroupRecIdRef: inputs.ProductGroupRecIdRef
                ? parseInt(inputs.ProductGroupRecIdRef)
                : null,
              ProductCatgRecIdRef: inputs.ProductCatgRecIdRef
                ? parseInt(inputs.ProductCatgRecIdRef)
                : null,
              UOMRecIdRef: inputs.UOMRecIdRef
                ? parseInt(inputs.UOMRecIdRef)
                : null,
              Price: inputs.Price ? parseFloat(inputs.Price) : null,
              Percentage: inputs.Percentage
                ? parseFloat(inputs.Percentage)
                : null,
              CalcTypeRecIdRef: inputs.CalcTypeRecIdRef
                ? parseInt(inputs.CalcTypeRecIdRef)
                : null,
              RevGLRecIdRef: inputs.RevGLRecIdRef
                ? parseInt(inputs.RevGLRecIdRef)
                : null
            },
            where: { RecId: parseInt(product.RecId) }
          }
        });
        toast.success("Product updated successfully.");
        onComplete();
      } catch (err) {
        console.log(err.message);
      }
    }
  };

  if (!codes) return <Loading />;

  return (
    <form
      className="add-item-form"
      id="edit-product-form"
      onSubmit={handleSave}
    >
      <Title>Edit Product</Title>
      <Fieldset disabled={loading}>
        <ProductForm
          codeStates={codes}
          inputs={inputs}
          onChange={handleChange}
        />
        <hr />
        <EditFormButtonGroup
          deleteMutation={DELETE_PRODUCT_MUTATION}
          form="edit-product-form"
          refetchQueries={["ALL_PRODUCTS_QUERY"]}
          variables={{ where: { RecId: product.RecId } }}
          onComplete={onComplete}
        />
      </Fieldset>
    </form>
  );
};

EditProductForm.propTypes = {
  onComplete: PropTypes.func,
  product: PropTypes.object
};
export default EditProductForm;
